<template>
  <b-input
    v-bind="$attrs"
    v-mask="brazilianPhoneMask"
    :state="state"
    :value.sync="value"
    @change="changeValue"
  />
</template>

<script>
import { brazilianPhoneMask } from '@/services/maskService';

export default {
  computed: {
    brazilianPhoneMask() {
      return [...brazilianPhoneMask];
    },
  },
  props: {
    value: null,
    state: null,
  },
  methods: {
    changeValue(newVal) {
      this.$emit('input', newVal);
    },
  },
};
</script>
